const reserve = () => import('@/views/main/reserve/reserve.vue')
export default {
  path: '/main/reserve',
  name: 'reserve',
  component: reserve,
  children: []
}
